var chunkMapping = {
	"195": [
		"0d91243d7ca22c7c3729",
		"387c329036ddf7577c5a",
		"4f49769c6cf88d3c8f38",
		"e84b0e7a43628557bd65",
		"ea2492ec19be82286b06",
		"fe1a964b5d52c55fcf99"
	],
	"240": [
		"99ebd20fad84b5cce231"
	],
	"361": [
		"7eff560850f2e8b31809"
	],
	"748": [
		"df0e1388e551b18043b7"
	]
};
var idToExternalAndNameMapping = {
	"0d91243d7ca22c7c3729": [
		"default",
		"./aggregator-store",
		"69acf2f284296c992bec"
	],
	"387c329036ddf7577c5a": [
		"default",
		"./admin-routes",
		"48f72acb077a53bc812d"
	],
	"4f49769c6cf88d3c8f38": [
		"default",
		"./admin-store",
		"48f72acb077a53bc812d"
	],
	"e84b0e7a43628557bd65": [
		"default",
		"./aggregator-comm",
		"69acf2f284296c992bec"
	],
	"ea2492ec19be82286b06": [
		"default",
		"./aggregator-routes",
		"69acf2f284296c992bec"
	],
	"fe1a964b5d52c55fcf99": [
		"default",
		"./admin-comm",
		"48f72acb077a53bc812d"
	],
	"99ebd20fad84b5cce231": [
		"default",
		"./platform-store",
		"3ad34f6858e40f8882cd"
	],
	"df0e1388e551b18043b7": [
		"default",
		"./platform-routes",
		"3ad34f6858e40f8882cd"
	],
	"7eff560850f2e8b31809": [
		"default",
		"./platform-comm",
		"3ad34f6858e40f8882cd"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}